import Swiper, { Navigation, A11y } from 'swiper';
import { STANDARD_CAROUSEL_BREAKPOINTS, INLINE_CAROUSEL_BREAKPOINTS } from './constants';
Swiper.use([Navigation, A11y]);

interface CarouselSectionProps {
    el: HTMLElement;
}

const CarouselSection = ({ el }: CarouselSectionProps): void => {
    const carousel: HTMLElement | null = el.querySelector('.carousel');
    const controlNext: HTMLElement | null = el.querySelector('.carousel-control-next');
    const controlPrev: HTMLElement | null = el.querySelector('.carousel-control-prev');

    if (!carousel || !controlNext || !controlPrev) {
        return;
    }

    const carouselSection = new Swiper(carousel, {
        init: false,
        navigation: {
            nextEl: controlNext,
            prevEl: controlPrev,
        },
        pagination: false,
        breakpoints: el.classList.contains('inline') ? INLINE_CAROUSEL_BREAKPOINTS : STANDARD_CAROUSEL_BREAKPOINTS,
    });

    carouselSection.init();
};

export default CarouselSection;
